import { SET_ALERT, SET_SIDEBAR, SET_PAGE_TITLE } from "./constants";

export const setAlert = value => ({ type: SET_ALERT, payload: value })

export const setSideBar = value => ({ type: SET_SIDEBAR, payload: value })

export const setPageTitle = value => ({ type: SET_PAGE_TITLE, payload: value })